<template>
  <div>장치 목록</div>
</template>

<script setup></script>
